<template>
	<div :class="classNames">
		<el-steps simple v-if="$route.name === 'CreateColumn'">
			<el-step title="第一步:课程详情内容" class="el-steps-color"></el-step>
			<el-step title="第二步:批量创建课程"></el-step>
		</el-steps>
		<!-- <div :class="classNames + '_disabled'" v-if="readOnly"></div> -->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="top">
			<el-form-item label="讲师介绍" prop="author_desc">
				<template slot="label">
					<span>讲师介绍</span>				
					<el-popover
					    width="400"
						placement="top-start"
						trigger="hover"
						>
						<span>讲师介绍：需包含但不仅限于：讲师资质（如心理、法律、健身等强依赖专业性的）、行业背景、历史成就等;“我是谁”+“我的学历背景”/“我的过往经验”/“擅长什么”等元素。</span>
						<div style="color:red">可在店铺管理-基本信息中进行修改</div>
						<img slot="reference"  class="question" src="http://img-dbzd.doubaozhidao.com/20220815/BbMJD3pBZMDE3aTcJBAYDpW7FsZfW5SE1660554235280.png?x-oss-process=image/quality,q_80/format,png" alt="">
					</el-popover>
				</template>
				<div :class="classNames + '_from_item_con'">
					<el-input placeholder="讲师介绍需在30～200字之间" v-model="userInfo.desc" disabled maxlength="200"></el-input>
				</div>
			</el-form-item>
			<el-form-item label="分类标签" prop="cate_id">
				<div :class="classNames + '_from_item_con'" v-disabled="readOnly()">
					<el-cascader
					placeholder="分类标签"
					:options="cateList"
					v-model="ruleForm.cate_id"
					@change="changeCate"
					ref="cascaderCate"
					filterable :props="{value:'id', label: 'title', children: '_child'}"></el-cascader>
				</div>
				
			</el-form-item>
			<el-form-item label="" v-if="cate_desc">
				<p style="color: red; width: 700px; word-break: break-all;line-height: 20px;">分类适用范围：{{cate_desc}}</p>
			</el-form-item>
			<el-form-item label="课程标题" prop="title">
				<template slot="label">
					<span>课程标题</span>
						<el-popover
						placement="top-start"
						trigger="hover"
					    width="400"
						>
						<span>课程标题：课程标题请尽量简洁清晰、标题应体现课程/课时核心知识内容、不得仅使用无意义的数字或字母作为课程/课时标题；</span>
												<img slot="reference"  class="question" src="http://img-dbzd.doubaozhidao.com/20220815/BbMJD3pBZMDE3aTcJBAYDpW7FsZfW5SE1660554235280.png?x-oss-process=image/quality,q_80/format,png" alt="">

					</el-popover>
					<el-popover
						placement="right-end"
						trigger="hover"
						>
						<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250167647330.jpeg"/>
						<span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
					</el-popover>
				
				</template>
				<div :class="classNames + '_from_item_con'" v-disabled="readOnly(ruleFormObj.dy_product_status === 2)">
					<el-input placeholder="标题限制在12-60字符之间（汉字占2个字符）" v-model="ruleForm.title" minlength="12" maxlength="60"></el-input>
				</div>
			</el-form-item>
			<el-form-item label="课程副标题" prop="subtitle">
				<template slot="label">
					<span>课程副标题</span>
					<el-popover
						placement="right-end"
						trigger="hover"
						>
						<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250369210876.jpeg"/>
						<span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
					</el-popover>
				</template>
				<div :class="classNames + '_from_item_con'" v-disabled="readOnly()">
					<el-input placeholder="请输入课程副标题(20字以内)" v-model="ruleForm.subtitle" maxlength="20" ></el-input>
				</div>
			</el-form-item>
			<el-form-item label="课程定价" prop="price">
				<template slot="label">
					<span>课程定价</span>
					<el-popover
				    placement="right-end"
				    trigger="hover"
				    >
					<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250104056940.jpeg"/>
				    <span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
				  </el-popover>
				</template>
				<div :class="classNames + '_from_item_con'" v-disabled="readOnly(ruleFormObj.dy_product_status === 2)">
					<el-input placeholder="支持小数点后两位" v-model="ruleForm.price" @input="handlePrice"></el-input>
				</div>
			</el-form-item>
			<div style="display:flex;position: relative;">
				<el-form-item label="内容封面" v-disabled="readOnly()" prop="bigimg" style="margin-right: 24px;flex-shrink:0">
					<template slot="label">
						<span>内容封面</span>
						<el-popover
						placement="right-end"
						trigger="hover"
						>
						<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250409332905.jpeg"/>
						<span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
					</el-popover>
					</template>
					<el-radio-group v-model="ruleForm.bigimg_type">
						<el-radio :label="1">图片</el-radio>
						<el-radio :label="2">视频</el-radio>
					</el-radio-group>
					<div :class="classNames + 'from_item_con'" style="display:flex" v-disabled="readOnly()">
						<uploader-img v-show="ruleForm.bigimg_type === 1" :boxH="240" :boxW="320" :ratio="[4,3]" size="750*564" v-model="bigimgConType.bigimg"
							cropperW="320" cropperH="240"
							@change="(url)=> changeUploadUrl(url, 'bigimg')"
							id="bigimg" dialogWidth="800px">
						</uploader-img>
						<uploader-video :isDestory="ruleForm.bigimg_type === 1" v-show="ruleForm.bigimg_type !== 1" v-model="bigimgConType.bigimg" @changeUrl="(url)=> changeUploadUrl(url, 'bigimg', '&x-oss-process=video/snapshot,t_1000,f_jpg')"></uploader-video>
					</div>
				</el-form-item>
				<el-form-item label="封面列表图" prop="list_width_img" label-position="left" v-show="bigimgConType.bigimg">
					<template slot="label">
						<span>封面列表图</span>
						<el-popover
						placement="right-end"
						trigger="hover"
						>
						<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250726941926.jpeg"/>
						<span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
					</el-popover>
					</template>
					<div :class="classNames + '_from_item_con'" v-disabled="readOnly(ruleFormObj.dy_product_status === 2)">
						<uploader-img @getFile="getFile" @change="(url)=> changeUploadUrl(url, 'img')" :boxH="90" :boxW="120" size="200*150"  :ratio="[4,3]" v-model="bigimgConType.img" id="img" cropperW="200" cropperH="150" :equalRatioNum="3"></uploader-img>
					</div>
				</el-form-item>
				<div class="showExample">
					<div class="title">内容封面示例图:</div>
					<div class="content">
						<img src="@/assets/image/img_tc_tu1.png" alt="">
						<img src="@/assets/image/img_tc_tu2.png" alt="">
					</div>
				</div>
			</div>
			<div class="preview" v-if="showPreview" @click="showPreview=!showPreview">
				<div class="pre_cons">
					<div class="content">
						<div v-html="preViewImg">{{preViewImg}}</div>
					</div>

					<div class="mask"></div>
					<div class="mask_header"></div>
				</div>
			</div>
			<el-form-item label="课程详情" prop="desc">
					<template slot="label">
					<span>课程详情</span>
					<el-popover
				    placement="right-end"
				    trigger="hover"
					width="400"
				    >
					<div class="class-desc">
						<span>课程详情需介绍该课程重点、教学形式、进程安排等基本情况。</span>
						<span>包括但不限于以下内容：</span>
						<span>①课程大纲：课程大概教什么内容、课程亮点、重点等；</span>
						<span>②教学形式：明确课程为直播/录播等形式；</span>
						<span>③面向人群：描述该课程的目标人群，如年龄、职业、兴趣程度划分等，或明确阐述学员需具备的基础能力；</span>
					    <span>④学完收获：描述学完该课程后能够掌握知识到什么程度，获得什么样的收益，便于用户正确合理选择。</span>
					</div>
				
				<img slot="reference"  class="question" src="http://img-dbzd.doubaozhidao.com/20220815/BbMJD3pBZMDE3aTcJBAYDpW7FsZfW5SE1660554235280.png?x-oss-process=image/quality,q_80/format,png" alt="">

				   
				  </el-popover>
				  <span style="color:red" v-if="staticPath === '/'">(因抖音政策要求内容仅支持50000字以内)</span>
				</template>
				<div :class="[classNames + '_from_item_con',classNames + '_from_item_con_editor']" v-disabled="readOnly()">
					
					<switch-template @preview="getPreview" @change="(item)=> { ruleForm.desc = item.content; templateId = item.id}"></switch-template>
					<quill-editor @quillUpload="quillUpload" ref="quill-editor" v-model="ruleForm.desc" :key="templateId" :placeholder="quillPlaceholder">
					</quill-editor>
					<uploads v-show="false" ref="quillUpload" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="false" uploadSize="5mb" @uploadSucess="getUrl"></uploads>
				</div>
				
			</el-form-item>
			<el-form-item label="挂载标题" prop="share_title" v-if="staticPath !== '/wx/'">
				<template slot="label">
					<span>挂载标题<span style="color:red">（锚点文案：建议12字以内更容易展示） </span></span>
					<el-popover
						placement="right-end"
						trigger="hover"
						>
						<img  src="http://img-dbzd.doubaozhidao.com/20231106/1699250058661422.jpeg"/>
						<span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
					</el-popover>
				</template>
				<div :class="classNames + '_from_item_con'" v-disabled="readOnly()">
					<el-input placeholder="抖音视频关联标题（请不要携带特殊字符）12字以内" v-model="ruleForm.share_title" maxlength="12"></el-input>
				</div>
			</el-form-item>
			<el-form-item label="发布平台" prop="channel" v-disabled="readOnly()">
				<div style="display:flex;">
					<el-checkbox-group v-model="ruleForm.channel">
						<el-checkbox v-for="item in filterReleaseTypeList" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
					</el-checkbox-group>
					<template v-if="staticPath == '/wx/' && userInfo.is_special==1">
						<span style="margin-left:30px; margin-right:30px; color:rgb(136, 138, 149);">展示位置</span>
						<el-select v-model="ruleForm.wx_mini" placeholder="请选择" class="select_option">
							<el-option
								v-for="item in optionsType"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</template>
				</div>
			</el-form-item>
			<el-form-item label="有效期至" prop="look_duration" label-position="left"  v-disabled="readOnly(ruleFormObj.dy_product_status === 2 || ruleFormObj.is_exists_dy === 1)">
				<div>
					<el-radio-group v-model="ruleForm.look_duration">
						<el-radio :label="1">永久有效</el-radio>
						<el-radio :label="2">1年有效</el-radio>
						<el-radio :label="3">3年有效</el-radio>
					</el-radio-group>
					<div style="font-size: 12px;color: red;line-height: 17px;margin-top: 10px;">有效期一经设置不可更改，谨慎选择！</div>
					<div style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
						提示：用户购买完课程可观看课程的时间有效期
					</div>
				</div>
			</el-form-item>
			<!-- <el-form-item label="分享描述" prop="share_sub_title">
				<div :class="classNames + '_from_item_con'">
					<el-input placeholder="请输入分享描述（请不要带特殊字符）10字以内" v-model="ruleForm.share_sub_title" maxlength="10"></el-input>
				</div>
			</el-form-item> -->
			
			<!--  推流隐藏 -->
			<!-- <el-form-item label="推流" prop="push_flow_status" label-position="left">
				<div v-disabled="readOnly()">
					<div style="font-size: 12px;line-height: 17px;color:#bdb2c8">
						平台通过投流、给予流量倾斜和扶持，每成交一单讲师可得订单金额的5%~15%
					</div>
					<el-switch
						v-model="ruleForm.push_flow_status"
					
						:active-value='1'
						:inactive-value='2'
						>
					</el-switch>
				</div>
			</el-form-item> -->
			<!-- <el-form-item label="课程素材" prop="material_type" label-position="left" v-if="userInfo.is_material == 1">
				<div v-disabled="readOnly()">
					<el-radio-group v-model="ruleForm.material_type">
						<el-radio :label="2">复制提取</el-radio>
						<el-radio :label="1">邮箱提取</el-radio>
					</el-radio-group>
					<div style="font-size: 12px;color: #888a95;line-height: 17px;margin-top: 10px;">
						<p v-if="ruleForm.material_type==2">用户购买后可自行复制链接提取</p>
						<p v-if="ruleForm.material_type==1">用户购买后可自动发送其邮箱</p>
					</div>
				</div>
			</el-form-item> -->
			<!-- <el-form-item prop="material" label-position="left" v-if="userInfo.is_material == 1">
				<div v-if="ruleForm.material_type==2" style="disply:flex;font-size: 12px;color: #888a95;" v-disabled="readOnly()">
					素材URL
					<el-input style="width:660px;margin-left:10px;" placeholder="文字类内容（包含但不限于网盘链接）" v-model="material_Url"></el-input>
				</div>
				<div :class="[classNames + '_from_item_con_editor']" style="width:660px" v-else v-disabled="readOnly()">
					<quill-editor @quillUpload="quillMaterialUpload" ref="quill-material-editor" v-model="material_product" :key="templateId" :placeholder="quillMaterialPlaceholder">
					</quill-editor>
					<uploads v-show="false" ref="quillMaterialUpload" uploadType="img" :accept="['.jpg','.png','.jpeg']" :multiple="false" uploadSize="5mb" @uploadSucess="getMaterialUrl"></uploads>
				</div>
			</el-form-item> -->
			<el-form-item v-if="$route.name ==='EditColumn'">
				<p style="color: red; width: 700px; word-break: break-all;line-height: 20px;">修改封面图片、课程名称/副标题、挂载标题、课程介绍、发布平台需要再次审核，请确认必要后再进行修改，以免影响您的课程正常售卖。</p>
			</el-form-item>
			<el-form-item>
				<div :class="[classNames + '_operat', classNames + '_from_item_con']" v-if="!readOnly()" >
					<!-- <el-button type="primary" @click="saveDraft" v-if="(!readOnly && ruleForm.status == 4) || $route.meta.saveBtnFlag" :disabled=" isSaveFlag || !backTitFlag">保存草稿</el-button> -->
					<el-button type="primary" @click="submitForm('ruleForm', 4)"  v-if="$route.name === 'CreateColumn'">
						下一步
					</el-button>
					<el-button type="primary" @click="submitForm('ruleForm', 1)"  v-else-if="$route.name === 'EditColumnOther'">
						提交审核
					</el-button>
					<el-button type="primary" @click="submitForm('ruleForm', 1)" :disabled="!backTitFlag" v-else>
						提交编辑
					</el-button>
					<!--<el-button type="primary" @click="goBack">返回</el-button> -->
				</div>
			</el-form-item>
		</el-form>

	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	import uploaderImg from '@/components/upload/upload.vue'
	import uploaderVideo from './uploadVideo'
	import quillEditor from '@/components/quillEditor/quillEditor.vue'
	import uploads from '@/components/newUpload/upload.vue'
	import { common } from '../../mixin/common.js'
	import chapterList from '@/components/chapterList/chapterList.vue'
	import chapterGroup from '@/components/chapterGroup/chapterGroup.vue'
	import switchTemplate from '@/components/switchTemplate/switchTemplate.vue'
	import staticPathTitle,{ getPlatInfo } from '@/utils/baseUrl.js'
	export default {
		name: 'CreateColumn',
		mixins: [common],
		data() {
			let validateSpecialCharacters = (rule, value, callback, title) => {
				if (value === '') {
				  callback(new Error(title));
				} else {
					var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
					if(patrn.test(value)) {
						callback(new Error('输入内容中含有特殊字符'));
					}
					let keyWords = this.keyWordList.find(item => value.toLocaleLowerCase().replace(/\s/g,"").includes(item.toLocaleLowerCase().replace(/\s/g,"")))
					let platformType = staticPathTitle[this.staticPath].label
					if(keyWords) {
						callback(new Error(keyWords + '为' + platformType + '敏感词请更换'))
					}
					if(rule.field == 'share_title') {
						const len = strLength(value)
						if( len < 1 || len > 24) {
							callback(new Error('挂载标题限制在1-12字之间'))
						}
					}
				  	callback();
				}
			}
			// let validateMaterial = (rule, value, callback,title) => {
			// 	if(!this.materialFlag){
			// 		if (value && !(value.includes('weiyun.com') || value.includes('pan.baidu.com') || value.includes('yunpan.360.cn') || value.includes('aliyundrive.com'))) {
			// 			callback(new Error('网址不正确'))
			// 		} else {
			// 			callback()
			// 		}
			// 	}else{
			// 		if(value === '') {
			// 			callback(new Error(title))
			// 		} else {
			// 			let keyWords = this.keyWordList.find(item => value.toLocaleLowerCase().replace(/\s|\&nbsp\;/g,"").includes(item.toLocaleLowerCase().replace(/\s/g,"")))
			// 			let platformType = this.staticPath === '/' ? '抖音': '快手'
			// 			if(keyWords) {
			// 				callback(new Error(keyWords + '为' + platformType + '敏感词请更换'))
			// 			}
			// 			callback()
			// 		}
			// 	}
				
			// }
			let validatePrice = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入课程定价'))
				} else {
					if(this.ruleForm.cate_id == 15 && value>0) {
						callback(new Error('免费专区课程定价只能为0'))
					} 
					if(this.staticPath === '/') {
						const limitPrice = [10, 10000]
						value * 100 <= limitPrice[0] * 100 || value * 100 >= limitPrice[1] * 100  ? callback(new Error(`课程单价需大于${limitPrice[0]}元,小于${limitPrice[1]}元`)) : ''
					} else {
						value * 100 > 1000000  ? callback(new Error('课程单价最高为1万')) : ''
					}
					callback();
				}
			}
			const keywordRule = (rule, value, callback,title) => {
				if(value === '') {
					callback(new Error(title))
				} else {
					if(rule.field == 'desc') {
						if(this.staticPath === '/' && value.length > 50000) {
							callback(new Error(title + '限制50000字以内'))
						}
						let className = 'keyWordText'
						let Div =  document.querySelector('.keyWordText')
						if(!Div) {
							Div = document.createElement('div')
							Div.className=className
							Div.style = 'display:none'
							document.body.appendChild(Div)
						}
						Div.innerHTML = value
						value = Div.innerText
						Div ? document.body.removeChild(Div) : ''
					}
 					let keyWords = this.keyWordList.find(item => value.toLocaleLowerCase().replace(/\s|\&nbsp\;/g,"").includes(item.toLocaleLowerCase().replace(/\s/g,"")))
					let platformType =  staticPathTitle[this.staticPath].label
					if(keyWords) {
						callback(new Error(keyWords + '为' + platformType + '敏感词请更换'))
					}
					if(rule.field == 'title') {
						let strValue =  value.replace(/\【/g,"")
						strValue = strValue.replace(/\】/g,"")
						strValue = strValue.replace(/\《/g,"")
						strValue = strValue.replace(/\》/g,"")
						const len = strLength(strValue)
						console.log('strValue',strValue,len);
						if( len < 12 || len > 60) {
							callback(new Error('标题限制在12-60字符之间（汉字占2个字符）'))
						}
					}
					console.log(this.ruleForm.desc.length, '...value')
					
					callback()
				}
			}
	  
			const strLength = (data) => {
			    var realLength = 0, len = data.length, charCode = -1;
			    for (var i = 0; i < len; i++) {
			        charCode = data.charCodeAt(i);
			        if (charCode >= 0 && charCode <= 128) realLength += 1;
			        else realLength += 2;
			    }
			    return realLength;
			}
			return {
				classNames: 'createColumn',
				red_input:'',//自定义红包数值
				ruleForm: {
					img: '',
					cate_id: [],
					title: '',
					subtitle: '',
					price: '',
					// sort: '',
					bigimg: '',
					desc: '',
					share_title: '',
					// product_material:'',
					// share_sub_title: '',
					// material: '',
					rights_desc: '',
					status: '',
					channel: [staticPathTitle[this.staticPath].value],
					push_flow_status: 2,//开启推流状态  1-开 2-关'
					list_width_img: '',
					// is_push_task: 1,
					material_type:2,
					look_duration: '',
					wx_mini:1,
					bigimg_type: 1
				},
				bigimgConType: {},
				keyWordList: [],
				ruleListObj: {
					title: '课程标题',
					subtitle: '课程副标题',
					desc: '课程介绍',
					share_title: '分享标题'
				},
				// isAuOrVidValue: 1,
				// isHorOrVerValue: '',
				backTitFlag: false,
				// isSaveFlag: false,
				ruleFormObj: {},
				// readOnly: false,
				// materialFlag:2,
				isHasChapterFlag: false,
				isChatpterTit: false,
				// isClickFlag: false,
				// isSubmitFlag: false,
				rules: {
					img: [{
							required: true,
							message: '请上传封面列表图',
							trigger: 'change'
						}
					],
					list_width_img: [{
							required: true,
							message: '请上传封面列表图',
							trigger: 'change'
						}
					],

					cate_id: [{
						required: true,
						message: '请选择分类标签',
						trigger: 'change'
					}],
					title: [{
						required: true,
						// message: '请输入课程标题',
						trigger: 'change',
						validator: (rule, value, callback) =>  {
							keywordRule(rule, value, callback, '请输入课程标题')
						}
					}],
					subtitle: [{
						required: true,
						// message: '请输入课程副标题',
						trigger: 'change',
						validator: (rule, value, callback) =>  {
							keywordRule(rule, value, callback, '请输入课程副标题')
						}
					}],
					price: [{
						required: true,
						validator: validatePrice,
						// message: '请输入课程定价',
						trigger: 'blur'
					}],
					
					// sort: {
					// 	required: true,
					// 	message: '请输入排序',
					// 	trigger: 'change'
					// },
					bigimg: {
						required: true,
						// message: '请上传内容封面',
						trigger: 'none',
						validator: (rule, value, callback) => {
							if(!this.bigimgCon[this.ruleForm.bigimg_type].bigimg) {
								callback(new Error('请上传内容封面'))
							}
							callback()
						},
					},
					desc: {
						required: true,
						// message: '请输入课程介绍',
						trigger: 'input',
						validator: (rule, value, callback) => {
							keywordRule(rule, value, callback, '请输入课程介绍')
						},
					},
					share_title: {
						required: true,
						validator: (rule, value, callback) => {
							validateSpecialCharacters(rule, value, callback, '请输入分享标题')
						},
						trigger: 'change'
					},
					// share_sub_title: {
					// 	required: true,
					// 	validator: (rule, value, callback) => {
					// 		validateSpecialCharacters(rule, value, callback, '请输入分享描述')
					// 	},
					// 	trigger: 'change'
					// },
					// material: {
					// 	required: false,
					// 	validator: (rule, value, callback) => {
					// 		validateMaterial(rule, value, callback, '请输入图文素材')
					// 	},
					// 	trigger: 'blue'
					// },
					rights_desc: {
						required: true,
						message: '请输入课程版权介绍',
						trigger: 'input'
					},
					charterList: {
						required: true,
						validator: (rule, value, callback) => {
							if(!this.isHasChapterFlag) {
								callback(new Error('请上传章节列表'))
							}
							callback()
						},
						trigger: 'change'
					},
					channel: [
						{ type: 'array', required: true, message: '请选择发布平台', trigger: 'change' }
					],
					look_duration: {
						required: true, 
						trigger: 'change',
						validator: (rule, value, callback) => {
							if(!value) {
								callback(new Error('请选择课程有效期'))
							}
							callback()
						},
					}
				},
				material_product:'',
				material_Url:'',
				productId: 0,
				templateId:'',
				quillPlaceholder: '<div style="display:flex;flex-direction:column"><span style="color:red">课程详情需介绍该课程重点、教学形式、进程安排等基本情况。</span><span>包括但不限于以下内容：</span><span>①课程大纲：课程大概教什么内容、课程亮点、重点等；</span><span>②教学形式：明确课程为直播/录播等形式；</span><span>③面向人群：描述该课程的目标人群，如年龄、职业、兴趣程度划分等，或明确阐述学员需具备的基础能力；</span><span>④学完收获：描述学完该课程后能够掌握知识到什么程度，获得什么样的收益，便于用户正确合理选择。</span></div>',
			quillMaterialPlaceholder:'<div style="display:flex;flex-direction:column"><span>选填（支持百度云盘、360云盘、腾讯微云等市场主流云盘链接，以及图文内容）</span></div>',

				platPath: '',
				preViewImg:'',
				showPreview:false,
				cate_desc: '',
				optionsType:[
					{
						label:'豆包知道',
						value:1
					},
					{
						label:'豆包甄选',
						value:2
					}
				],
			}
		},
		beforeRouteLeave(to,form,next) {
			next(false)
			// console.log(this.ruleForm.status, this.$route.meta.saveBtnFlag, 'ooo')
			if(((this.$route.name == 'EditColumn' && this.ruleForm.status == 4)|| this.$route.meta.saveBtnFlag) && !this.isChatpterTit) {
				this.goBack((flag) => {
					if(flag) {
						this.saveDraft(next, to.path)
					} else {
						this.cancelRouter('')
						next()
					}
					
				}, to.path)
			} else {
				this.cancelRouter('')
				next()
			}
		},
		components: {
			'uploader-img': uploaderImg,
			'uploader-video': uploaderVideo,
			'quill-editor': quillEditor,
			uploads,
			'chapter-list': chapterList,
			'chapter-group': chapterGroup,
			'switch-template': switchTemplate,
		},

		mounted() {
			window.addEventListener('beforeunload', this.beforeunload)
		},
		created() {
			this.getCateList({product_id: this.$route.params.id})
			this.getSensitiveFun()
			this.getUserInfo()
			// if(this.$route.name === 'PreivewColumn') {
			// 	this.readOnly = true
			// }
			if(this.$route.params.id) {
				this.productId = this.$route.params.id;
				this.specialinfo({id: this.$route.params.id})
			}		
			this.ruleFormObj = JSON.parse(JSON.stringify(this.ruleForm))
			// this.platPath = localStorage.getItem('platPath')
			this.platPath = getPlatInfo().path
		},
		computed: {
			...mapState(['breadCrumbList']),
			...mapState('createClass', ['cateList']),
			...mapState('column', ['detailColumnObj', 'saveId']),
			...mapState('login',  ['userInfo']),
			iconImg() {
				let img = this.ruleForm.list_width_img || this.ruleForm.bigimg
				if(this.isVideo) {
					img = img + '&x-oss-process=video/snapshot,t_1000,f_jpg'
				}
				if(img && !img.includes('timestamp=')){
					const randomString = this.randomString(6)
					const t = `&timestamp=${randomString}`
					img += t
				}
				this.ruleForm.img = img
				// this.ruleForm.bigimg  = img
				this.ruleForm.list_width_img  = img
				return img
			},
			filterReleaseTypeList() {
				return this.releaseTypeList.reduce((pre, item)=> {
					if(item.includesList.includes(this.staticPath)) {
						pre.push(item)
					}
					return pre
				}, [])
			},
			readOnly() {
				return (flag) => {
					return this.$route.name === 'PreivewColumn' || flag
				}
			},
			// cate_desc() {
				// const cascaderCate = this.$refs.cascaderCate.getCheckedNodes()
				// return cascaderCate.data.use_scope
			// },
			// bigimgConType(){
			// 	return this.bigimgCon[this.ruleForm.bigimg_type]
			// },
			bigimgCon: {
				get(news) {
					const list = [1, 2]
					const bigimg_type = this.ruleFormObj.bigimg_type || 1
					const res = list.reduce((pre, item) => {
						if(bigimg_type === item) {
							pre[item] = {
								img: this.ruleFormObj.img || this.ruleFormObj.list_width_img || this.ruleFormObj.bigimg,
								bigimg: this.ruleFormObj.bigimg
							}
						} else {
							pre[item] = {
								img: '',
								bigimg: ''
							}
						}
						return pre
					}, {})
					return res
				},
				set(news) {
					const img = news[this.ruleForm.bigimg_type].img
					this.ruleForm.list_width_img = img
					this.ruleForm.img = img
					this.ruleForm.bigimg = news[this.ruleForm.bigimg_type].bigimg
				}
			}
		},
		methods: {
			...mapActions('column', ['specialinfo', 'createdspecial']),
			...mapActions('createClass', ['getCateList']),
			...mapActions('class', ['productUpdate', 'getSensitive']),
			...mapActions('login', ['getUserInfo']),
			...mapMutations(['cancelRouter']),
			getFile(url) {
			},
			redPrevent(e){
				var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
				    if (keynum ==189|| keynum==190||keynum == 109 ||keynum == 110 ) {
				        this.$message.warning('禁止输入小数以及负数')
				        e.target.value = ''
				    }
			},
			quillUpload() {
				this.$refs.quillUpload.uploadFile()
			},
			quillMaterialUpload(){
				this.$refs.quillMaterialUpload.uploadFile()
			},
			getUrl(list) {
				this.$refs['quill-editor'].insertImg(list[0].url)
			},
			getMaterialUrl(list){
				this.$refs['quill-material-editor'].insertImg(list[0].url)
			},
			async saveDraft(next, path, flag= false) {
				this.$message.closeAll()
				let params = this.$route.params.id ? {
					...this.ruleForm,
					status: 4,
					id: this.$route.params.id,
					cate_id: this.ruleForm.cate_id.join(',')
				} : {
					...this.ruleForm,
					status: 4,
					cate_id: this.ruleForm.cate_id.join(',')
				}
				let res = await this.createdspecial(params)
				if(path == '/login') {
					await this.cancelRouter('login')
				} else {
					await this.cancelRouter('back')
				}
				await this.cancelRouter('')
				next()
				// this.isClickFlag = false
				if(res !== 'success') {
					return
				}
				// this.isSaveFlag = true
				this.$message({
					type: 'success',
					message: '保存成功'
				})
				// this.$refs.ruleForm.validateField('material', async (res) => {
				// 	if(!res) {
						
				// 	} else {
				// 		this.messageOption = this.$message({
				// 			message: '素材URL格式错误',
				// 			showClose: true,
				// 			duration: 0,
				// 			type: 'error'
				// 		})
				// 	}
				// })
			},
			handlePrice() {
				this.ruleForm.price = this.ruleForm.price.replace(/[^0-9.]/g, '')
				if (this.ruleForm.price.indexOf('.') > 0) {
					this.ruleForm.price = this.ruleForm.price.slice(0, this.ruleForm.price.indexOf('.') + 3)
				}
			},
			handleSort(value) {
				this.ruleForm.sort = this.ruleForm.sort.replace(/[^0-9]/g, '')
				if (this.ruleForm.sort < 0 || this.ruleForm.sort > 1000) {
					this.ruleForm.sort = this.ruleForm.sort.slice(0, this.ruleForm.sort.length - 1)
				}
			},
			isVidOrAu(value) {
				if(value == 2) {
					this.ruleForm.type = 2
				}
			},
			isHorOrVer(value) {
				this.ruleForm.type = value
			},
			// goBack() {
			// 	this.$router.go(-1)
			// },
			submitForm(formName, type) {
				console.log('表单内容1',this.ruleForm)
				if(this.ruleForm.desc) {
					this.ruleForm.desc = this.ruleForm.desc.replace(/<!--(.|[\r\n])*?-->/g,"")
				}
				
				this.$refs[formName].validate(async (valid, errorList) => {

					if (valid) {

						// if(this.isSubmitFlag) {
						// 	return
						// }
						// this.isSubmitFlag = true
						// this.ruleForm.material_type==1?(this.ruleForm.material=this.material_product):(this.ruleForm.material = this.material_Url)
						let params = this.$route.params.id ? {...this.ruleForm, status: type, id: this.$route.params.id} : {...this.ruleForm, status: type }
						console.log(params,'params----')
						params.cate_id = this.ruleForm.cate_id.join(',')
						if(params.status == 1) {

							if(this.detailColumnObj.status == 1) {
								params.product_id = this.$route.params.id
								await this.productUpdate(params)
								this.$confirm('<p style="color:red">修改内容已提交审核，需平台审核后方可同步</p>', '信息', {
									dangerouslyUseHTMLString: true,
									distinguishCancelAndClose: false,
									showCancelButton: false,
									confirmButtonText: '确定',
									showClose: false,
									closeOnClickModal: false,
									closeOnPressEscape: false,
									customClass: this.classNames + '_common_dialog',
									center: true
								}).then(res => {
									this.$router.replace(this.staticPath +  'specialColumn')
								})
							} else {
								this.detailColumnObj.status == 4? params.status = 1 : ''
								await this.createdspecial(params)
								this.$router.replace(this.staticPath +  'specialColumn')
								await this.$message({
									type: 'success',
									message: '提交成功'
								})
							}
						} else {
							this.isChatpterTit = true
							await this.createdspecial(params)
							this.handleBreadCrumb(`${this.staticPath}createColumn/${this.saveId}`, '新建课程', '', 2,'',false)
							this.handleBreadCrumb(`${this.staticPath}chapter/${this.saveId}/column`, '章节列表', '', 3, 'replace')
						}
						this.backTitFlag = false
					} else {
						let msg = ''
						for (const key in errorList) {
							msg = this.ruleListObj[key] &&  errorList[key][0].message.includes('敏感词请更换')? this.ruleListObj[key] + ':' +  errorList[key][0].message : errorList[key][0].message
							break;
						}
						this.$message.closeAll()
						this.messageOption = this.$message({
							message: msg,
							showClose: true,
							duration: 0,
							type: 'error'
						})
						return false;
					}
				});
			},
			handleBreadCrumb(path, name, id, index = 2,routerType='replace', isRouterFlag=true, isSliceFlag) {
				let breadCrumbList = isSliceFlag ? this.breadCrumbList.slice(0, index):this.breadCrumbList
				breadCrumbList[index] = {
					title: name,
					path: id ? path + '/' + id : path
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				if(isRouterFlag) {
					this.$router[routerType]({
						path: id ? path + '/' + id : path,
					})
				}
				
				// breadCrumbList[index] = {
				// 	title: name,
				// 	path: this.$route.fullPath
				// }
			},
			async addChapter() {
				if (this.productId < 1) {
					let params = this.$route.params.id ? {
						...this.ruleForm,
						status: 4,
						id: this.$route.params.id,
						cate_id: this.ruleForm.cate_id.join(',')
					} : {
						...this.ruleForm,
						status: 4,
						cate_id: this.ruleForm.cate_id.join(',')
					}
					this.isChatpterTit = true
					this.$store.commit('changeLoading', 'cancle')
					let res = await this.createdspecial(params)
					this.productId = this.saveId
				}

				// let breadCrumbList = this.breadCrumbList.slice()
				this.handleBreadCrumb(`/createColumn/${this.productId}/column`, '章节列表', '', 2, 'push', false)
				this.handleBreadCrumb(`/createChapter/${this.productId}/column`, '新建章节', '', 4,'push')
				// this.$router.push(`/createChapter/${this.saveId}/column`)
				// console.log(res, 'p222222')
			},
			goChapter() {
				this.isChatpterTit = true
				this.handleBreadCrumb(`/chapter/${this.$route.params.id}/column`, '章节列表', '',3, 'push')
			},
			async addGroup() {
				if (this.productId < 1) {
					let params = {
						...this.ruleForm,
						status: 4
					};
					if (this.$route.params.id) {
						params.id = this.$route.params.id
					}
					params.cate_id =  this.ruleForm.cate_id.join(',')
					this.isChatpterTit = true
					this.$store.commit('changeLoading', 'cancle')
					await this.createdspecial(params);
					this.productId = this.saveId;
				}

				this.$refs.groupRefChild.addGroup();
			},
			beforeunload() {
			},
			async getSensitiveFun() {
				let res = await this.getSensitive()
				this.keyWordList = res
			},
			getPreview(item){
				console.log(item)
				this.preViewImg = item.content
				this.showPreview = true
			},
			changeUploadUrl(url,type, unit='') {
				if(url && !url.includes('timestamp=')){
					const unit = url.indexOf('?') !== -1? '&': '?'
					const randomString = this.randomString(6)
					const t = `${unit}timestamp=${randomString}`
					url += t
				}
				this.$set(this.bigimgCon[this.ruleForm.bigimg_type],[type], url)
				if(type !== 'img') {
					this.$set(this.bigimgCon[this.ruleForm.bigimg_type], 'img', url + unit) 
				}
				this.bigimgCon = { ...this.bigimgCon }
			},
			randomString(e) {
				e = e || 8;
				var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
					a = t.length,
					n = "";
				for (var i = 0; i < e; i++) {
					n += t.charAt(Math.floor(Math.random() * a))
				}
				return n + Date.now()
			},
			changeCate(data){
				if(data && data.length == 2){
					console.log('cateList',this.cateList,data);
					let res = this.findCateNode(this.cateList, item => item.id == data[1])
					this.cate_desc = res.use_scope
					console.log('findCateNode',res)
				}
			},
			findCateNode (tree, func) {
			  for (const data of tree) {
			    if (func(data)) return data
			    if (data._child) {
			      const res = this.findCateNode(data._child, func)
			      if (res) return res
			    }
			  }
			  return ''
			}
		},
		watch: {
			detailColumnObj: {
				deep: true,
				handler(news) {
					let detailColumnObj = JSON.parse(JSON.stringify(news))
					if(detailColumnObj.cate_id && detailColumnObj.cate_cid) {
						detailColumnObj.cate_id = [detailColumnObj.cate_id, detailColumnObj.cate_cid]
					} else if(detailColumnObj.cate_id) {
						detailColumnObj.cate_id = [detailColumnObj.cate_id]
					} else {
						detailColumnObj.cate_id = []
					}
					this.changeCate(detailColumnObj.cate_id)
		
					for (let k in detailColumnObj) {
						if(this.ruleForm.hasOwnProperty(k))  {
							this.ruleForm[k] = detailColumnObj[k]
						}
					}
					// if(detailColumnObj.material_type==1){
					// 	this.material_product = detailColumnObj.material
					// }
					// if(detailColumnObj.material_type==2){
					// 	this.material_Url = detailColumnObj.material
					// }
					this.ruleFormObj = JSON.parse(JSON.stringify(detailColumnObj))
					console.log(this.ruleFormObj,'this.ruleFormObj',news,'news')
				}
			},
			ruleForm: {
				deep: true,
				handler(news, olds) {
					let flag = false
					// this.isSaveFlag = false
					for (let k in news) {
						if (this.ruleFormObj.hasOwnProperty(k) && news[k] != this.ruleFormObj[k] && JSON.stringify(news[k]) != JSON.stringify(this.ruleFormObj[k])) {
							// console.log(news[k], k)
							// console.log(this.detailColumnObj[k], k)
							flag = true
							break;
						}
					}
					this.backTitFlag = flag
				}
			},
			material_product:{
				handler(news, olds) {
					console.log(news, 'p----')
					this.ruleForm.material = news
				}
			},
			material_Url:{
				handler(news, olds) {
					this.ruleForm.material = news
				}
			},
			'ruleForm.subtitle'(news){
				this.ruleForm.rights_desc=news
			},
			// saveId(news) {
			// 	if(news && this.$route.name === 'CreateColumn') {
			// 		this.$router.replace(`/createColumn/${news}`)
			// 	}
			// }
			bigimgCon: {
				deep: true,
				handler(news) {
					this.bigimgConType = news[this.ruleForm.bigimg_type]
				}
			},
			'ruleForm.bigimg_type'(news){
				this.bigimgConType = this.bigimgCon[news]
			}
			
		},
		directives: {
			disabled: {
				bind(el, data) {
					const { value } = data
					if(value) {
						el.style.position = 'relative'
						let divElement = document.createElement('div')
						divElement.style = 'position:absolute;top:0;left:0;bottom: 0;right: 0;z-index: 100;cursor: not-allowed'
						el.appendChild(divElement)
					}
				},
				update(el, data) {
					const { value } = data
					if(value) {
						el.style.position = 'relative'
						let divElement = document.createElement('div')
						divElement.style = 'position:absolute;top:0;left:0;bottom: 0;right: 0;z-index: 100;cursor: not-allowed'
						el.appendChild(divElement)
					}
				}
			}
		},
		beforeDestroy() {
			if(this.messageOption) {
				this.messageOption.close()
			}
			this.messageOption = ''
		}
	}
</script>
<style lang="less">
@classNames: createColumn;
.@{classNames}_charterList_con {
	.el-form-item__content {
		// display: none;
		height: 0;
	}
}
.red-border-box{
	width: 400px;
	display: flex!important;
	
	.red-border{
		.el-input__inner{
			border: 1px solid #DCDFE6!important;
		}
	}
}

</style>
<style lang="less" scoped>
	@classNames: createColumn;

	.@{classNames}_from_item_tit {
		margin-left: 6px;
	}
	.@{classNames}_operat {
		display: flex!important;
		justify-content: flex-end;
	}
	.@{classNames}_cate {
		margin-top: -12px;
		.el-radio {
			width: 100px;
			margin-top: 12px;
		}
	}
	.@{classNames}_class_content {
		.@{classNames}_radio {
			display: flex;
			flex-direction: column;
			position: relative;
			left: 20px;

			.el-radio {
				&:not(:first-child) {
					margin-top: 20px;
				}
			}
		}
	}
</style>
<style lang="less" scoped>
	@classNames: createColumn;
	.@{classNames} {
		position: relative;
		.@{classNames}_from_item_con {
			width: 660px;
			display: inline-block;

			&.@{classNames}_class_content {
				.@{classNames}_upload_vidOrau {
					display: flex;
				}
			}

		}
		.@{classNames}_disabled {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 40px;
			right: 0;
			z-index: 100;
		}
	}
	.question{
    	position: relative;
		left: 5px;
		top: 3px;
	  width: 17px;
	  height: 17px;
	  margin-right: 10px;
	}
	.class-desc{
		display: flex;
		flex-direction: column;
		:nth-child(1){
			color: red;
		}
	}
	.showExample{
		position: absolute;
		bottom: 22px;
		left:332px;
		.title{
			font-size: 14px;
			color: red;
			line-height: 32px;
			font-weight: 500;
		}
		.content{
			display: flex;
			img{
				display: block;
				width: 180px;
				height: 114px;
				margin-right: 30px;
			}
		}
	}
	.preview{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0, 0, 0, .6);
		.pre_cons{
			width:396px;
			height:795px;
			overflow: hidden;
			position: relative;
			.content{
				background: #fff;
				border-radius: 30px;
				position: absolute;
  				left: 26px;
				top: 23px;
				bottom: 25px;
				right: 27px;
  				overflow-x: hidden;
  				overflow-y: scroll;
				z-index: 888;
				
			}
			.content::-webkit-scrollbar {
    			display: none;
  			}
			.mask{
				position: absolute;
				top:0;
				left: 0;
				z-index: 8;
				width:396px;
				height:795px;
				background: url('~@/assets/image/img_tc_tu3.png') no-repeat;
				background-size: 100% 100%;
			}
			.mask_header{
				position: absolute;
				top:22px;
				left: 92px;
				z-index: 999;
				width:217px;
				height:29px;
				background: url('~@/assets/image/img_tu.png') no-repeat;
				background-size: 100% 100%;
			}
			
		}
	}
	.select_option{
		width:120px;
		height:30px;
		margin-top: 5px;
		/deep/.el-input{
			line-height: 30px;
			.el-input__inner{
				height: 30px;
			}
		}
		/deep/.el-input__icon{
			line-height: 30px;
		}
	}
</style>
